import styled from "@emotion/styled";
import { Container, Typography, Grid} from "@mui/material";
import React from "react";
import TokenBg from "../../../assets/Token-bg.png";

const MainContainer = styled(Container)`
    background-image:linear-gradient(to top, #000024, #00002e);

`
const TokeContainer = styled(Container)`
    background-image:url(${TokenBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding-top:80px;
    padding-bottom: 50px;
`
const ContentGrid = styled(Grid)`
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top:30px;
    @media (max-width: 900px){
        margin-top:15px;
    }
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family: poppins-b;
    text-align: center;
    margin-bottom: 30px;
    @media (max-width: 749px){
        font-size:30px;
        margin-bottom: 15px;
    }
`
const P = styled.p`
    color: #fff;
    font-size: 15px;
    font-family: poppins-light;
    text-align: center;
    width:85%;
    @media (max-width: 1100px){
        width:100%;
    }
`
const SubHeading = styled(Typography)`
    color:#fff;
    font-family: poppins-m;
    font-size:20px ;
    text-align: center;
    @media (max-width: 900px){
        font-size: 16px;
    }
`
const BoxGrid = styled(Grid)`
    padding:20px;
    @media (max-width: 1024px){
        padding:0px;
    }
`
const BoxWrapper = styled.div`
    background-color: #01014D;
    padding:40px 20px 50px 20px;
    border-radius: 10px;
    @media (max-width: 1000px){
        padding:20px 10px 30px 10px;
    }
`
const BoxHeading = styled(Typography)`
    color:#fff;
    font-family:poppins-m;
    font-size:30px;
    @media (max-width: 1000px){
        font-size: 18px;
    }
`
const BoxSubHeading = styled(Typography)`
    color:#fff;
    font-family:poppins;
    font-size:16px;
    margin-bottom: 20px;
    @media (max-width: 900px){
        font-size: 14px;
    }
`
const AdressGrid = styled(Grid)`
    padding-right:20px;
    @media (max-width: 1024px){
        padding-right:0px;
    }
`
const AdressWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    background-color:#fff;
    border-radius: 9px;
    padding:10px 20px 10px 20px;
    @media (max-width: 749px){
        padding:10px 10px 10px 10px;
    }
`
const AddressText = styled.p`
    color:#000;
    font-size:18px;
    overflow-wrap: anywhere;
    font-family:poppins-b;
    margin:0px;
    @media (max-width: 749px){
        font-size:16px;
    }
`
const TokenDetail = () => {
    return(
            <MainContainer maxWidth="xXl" id="details" >
                <TokeContainer maxWidth="xl" sx={{padding:'0px'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Heading data-aos="fade-right" variant="h1">Token Details</Heading>
                        </Grid>
                            <BoxGrid data-aos="zoom-in" item xs={6} sm={3} >
                                <BoxWrapper>
                                    <BoxSubHeading variant="h3">Name</BoxSubHeading>
                                    <BoxHeading variant="h3">Pulse Mixer</BoxHeading>
                                </BoxWrapper>
                            </BoxGrid>
                            <BoxGrid data-aos="zoom-in" item xs={6} sm={3} >
                                <BoxWrapper>
                                    <BoxSubHeading variant="h3">Symbol</BoxSubHeading>
                                    <BoxHeading variant="h3">$PMIX</BoxHeading>
                                </BoxWrapper>
                            </BoxGrid>
                            <BoxGrid data-aos="zoom-in" item xs={6} sm={3} >
                                <BoxWrapper>
                                    <BoxSubHeading variant="h3">Sypply</BoxSubHeading>
                                    <BoxHeading variant="h3">10 Billion</BoxHeading>
                                </BoxWrapper>
                            </BoxGrid>
                            <BoxGrid data-aos="zoom-in" item xs={6} sm={3} >
                                <BoxWrapper>
                                    <BoxSubHeading variant="h3">Taxes</BoxSubHeading>
                                    <BoxHeading variant="h3"> 4/5</BoxHeading>
                                </BoxWrapper>
                            </BoxGrid>
                            <AdressGrid item xs={12}>
                                <AdressWrapper>
                                    <AddressText>Copy Contract address:</AddressText>
                                    <AddressText>0x6Dafcd59F3Acb2b7D9253E4dc1A6f81D19687F22</AddressText>
                                </AdressWrapper>
                            </AdressGrid>
                        <ContentGrid item xs={12} sm={12}>
                            <SubHeading data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine" variant="h1">Disclaimer</SubHeading>
                            <P data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">Pulse Mixer is a DeFi crypto project, and 
                            participating in it carries inherent risks, including potential financial loss. The information provided on
                             this website or any affiliated platforms is for general informational purposes only and should not be 
                             considered financial advice. We make no warranties or representations regarding the accuracy or 
                             completeness of the information. It is essential to conduct your own research, seek professional
                              advice, and understand the risks associated with DeFi before engaging.
                             By using Pulse Mixer, you accept full responsibility for your actions and the risks involved.
                            </P>
                        </ContentGrid>
                    </Grid>
                </TokeContainer>
            </MainContainer>
    );
}

export default TokenDetail;